export default __webpack_public_path__ + "static/media/FemaleHeadRight.06c2d167.png";